<div class="font-bold text-2xl mb-5 ml-3 w-fit">
  Liens
  <hr class="ml-8 border-2 border-tertiary pr-10" />
</div>
<button
  class="rounded-3xl bg-secondary text-white font-semibold py-2 px-8"
  (click)="addLink()"
>
  Créer un lien
</button>
<div class="mx-16 my-5 !min-w-fit">
  @if (!store.loadingLinks() && store.total()===0){ Aucun lien } @else {
  <table
    mat-table
    matSort
    [dataSource]="store.links()"
    (matSortChange)="sortData()"
  >
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        mat-sort-header="name"
        *matHeaderCellDef
        class="rounded-tl-xl"
      >
        Nom du lien
      </th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="url">
      <th mat-header-cell mat-sort-header="url" *matHeaderCellDef>URL</th>
      <td mat-cell *matCellDef="let element">
        <a [href]="element.url">{{ element.url }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="button">
      <th mat-header-cell *matHeaderCellDef class="rounded-tr-xl">Action</th>
      <td mat-cell *matCellDef="let element">
        <app-action-button-bar
          [element]="element"
          [elementType]="'LINK'"
          (editEvent)="updateLink($event)"
          (deleteEvent)="deleteLink($event)"
          (sendNotificationEvent)="sendNotification($event)"
        ></app-action-button-bar>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    @if (store.loadingLinks()) {

    <div
      role="status"
      class="my-5 mx-16 p-4 space-y-4 border border-gray-200 divide-y divide-gray-200 rounded shadow animate-pulse dark:divide-gray-700 md:p-6 dark:border-gray-700"
    >
      <div class="flex items-center justify-between">
        <div>
          <div
            class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"
          ></div>
          <div class="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
      </div>
      <div class="flex items-center justify-between pt-4">
        <div>
          <div
            class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"
          ></div>
          <div class="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
      </div>
      <div class="flex items-center justify-between pt-4">
        <div>
          <div
            class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"
          ></div>
          <div class="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
      </div>
      <div class="flex items-center justify-between pt-4">
        <div>
          <div
            class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"
          ></div>
          <div class="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
      </div>
      <div class="flex items-center justify-between pt-4">
        <div>
          <div
            class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"
          ></div>
          <div class="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
      </div>
    </div>

    } @else {
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="select(row)"
    ></tr>
    }
  </table>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    (page)="handlePageEvent()"
    [pageIndex]="store.page() - 1"
    [pageSize]="store.pageSize()"
    [length]="store.total()"
    class="rounded-b-xl"
    showFirstLastButtons
  >
  </mat-paginator>
  }
</div>
